__webpack_require__.p = "/forge/documentation/";